module.exports = __webpack_public_path__ + "img/middle_18.38919c3c.png";